import React, {useState, useMemo} from 'react';
import Modal from '../master/Modal';
import {getDirection, hardCopy} from '../../utils/functions';
import {damagedPositions} from '../../utils/variables';
import { useTranslation } from 'react-i18next';

export default function PositionPicker({col = 6, label, data, value, placeholder, onSelect, required}) {

    const dataProps = useMemo(() => JSON.stringify({value, required, label}), [label, required, value]);
    const { t, i18n } = useTranslation();
    const [showPicker, setShowPicker] = useState(false);

    const selectedArray = useMemo(() => value ? value.split(', ') : [], [value]);

    function selectItem(item) {
        const array = hardCopy(selectedArray);
        const index = array.indexOf(item);
        if (index === -1) array.push(item); else array.splice(index, 1);
        onSelect(array.join(', '));
    }

    return (<div className={`col-${col}`} data-props={dataProps}>
        {label && <div className='mt10 mb5'><label>
            {required && <span className='required-icon'>* </span>}
            {label}
        </label>
        </div>}
        <div className={`input-parent ${getDirection(i18n.language) === 'rightToLeft' ? 'rtl' : 'ltr'}`}>
            <div className={`searchablePicker ${getDirection(i18n.language) === 'rightToLeft' ? 'rtl' : 'ltr'}`}>
                <div className='input' onClick={() => setShowPicker(true)}>
                    <div className='input-overflow'>
                        <span className='pickerText'>
                            {value 
                            // || <span>{placeholder || label}</span>
                            }
                        </span>
                    </div>
                </div>
                <Modal visible={showPicker}>
                    <div className='picker-content p10 d-flex flex-column'>
                        <ul>
                            {damagedPositions.map((item, index) => (<li key={index} className={getDirection(i18n.language) === 'rightToLeft' ? '' : 'd-flex'}>
                                <label className={`d-flex ${getDirection(i18n.language) === 'rightToLeft' ? '' : 'flex-row-reverse'}`}>
                                    <input
                                        type='checkbox'
                                        onChange={() => selectItem(t(item))}
                                        checked={selectedArray.indexOf(t(item)) !== -1}
                                        style={{verticalAlign: 'middle'}}
                                        className='ml10 mr10'
                                    />
                                    <span>{t(item)}</span>
                                </label>
                            </li>))}
                        </ul>
                        <button className='btn btn-green btn-circle' onClick={() => setShowPicker(false)}>{t('Confirm')}
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    </div>);

}
